import router from './router'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { getToken } from '@/utils/auth' // 验权
import { syncLocaleByRoute } from '@/i18n'

const whiteList = ['/', '/home', '/new-arrivals'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start()
  syncLocaleByRoute(to.path)
  if (getToken()) {
    next()
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      // 未登录用户访问其他页面时，弹出登录框
      next()
      // 延迟触发，确保 App 组件已挂载
      setTimeout(() => {
        // 通过事件总线触发显示登录对话框
        if (router.app && router.app.$root) {
          router.app.$root.$emit('show-login-dialog')
        }
      }, 200)
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js